<template>
  <v-container fluid class="pa-0 ma-0">
    <template v-if="!isLoading && challenge && challenge.properties && challenge.registrationModule">
      <m2h-unbox-challenge-widget-one mode="widget" v-if="challenge.registrationModule.registered && challenge.properties.customWidgetIdentifier && challenge.properties.customWidgetIdentifier === 'UNBOX_CHALLENGE_1'" :challenge-title="challenge.title" :challenge-id="challenge.identifier"></m2h-unbox-challenge-widget-one>
      <m2h-wefitter-challenge-widget mode="widget" v-if="challenge.registrationModule.registered && challenge.properties.weFitterType" :challenge-id="challenge.identifier" :challenge="translatedChallenge"></m2h-wefitter-challenge-widget>
    </template>
  </v-container>
</template>

<script>

import api from "@/api/api";

export default {
  name: "m2h-challenges-widget",
  props: ['challengeId'],
  data() {
    return {
      isLoading: true,
      challenge: {},
      challenges: [],
    }
  },

  computed: {
    translatedChallenge() {
      let challenge = {...this.challenge}

      challenge.translation = null
      if (challenge.contentStructure && challenge.contentStructure.asset && challenge.contentStructure.asset.assetTranslations.length){
        if (challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
          challenge.translation = challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
        }
      }
      return challenge
    }
  },

  mounted(){
    this.fetchChallenges()
  },

  methods: {
    /*async fetchChallenge(){
      this.isLoading = true
      this.challenge = await api.newsItems.getItem(this.challengeId).then((res) => { return res.data })
      this.isLoading = false
    },*/

    async fetchChallenges(){
      this.isLoading = true
      let challenges = []
      challenges = await api.challenges.getList().then((res) => { return res.data })
      if (challenges.length){
        this.challenges = challenges.sort((a, b) => {
          return this.$moment(a.createdAt).unix() - this.$moment(b.createdAt).unix()
        })
        for (const challenge of this.challenges) {
          if (challenge && challenge.registrationModule && challenge.registrationModule.identifier){
            challenge.registrationModule.registered = await api.userRegistrations.getRegistrationExists(challenge.registrationModule.identifier).then((res) => {
              return res.data
            })
          }
        }
        this.challenge = this.challenges.find((x) => { 
          return !!(x.properties && (x.properties.customWidgetIdentifier || x.properties.weFitterType) && x.registrationModule && x.registrationModule.registered);
        })
      }
      
      this.isLoading = false
    },
  }
}
</script>

<style scoped>

</style>
